import { Link } from 'react-router-dom';
import { featuredGenres } from '@/mocks/movies';

const mainEntries = [
  { label: '电影', desc: '全球佳片', icon: 'ri-film-line', to: '/category/movie' },
  { label: '电视剧', desc: '热播追剧', icon: 'ri-tv-2-line', to: '/category/tv' },
  { label: '国产专区', desc: '国剧精选', icon: 'ri-flag-2-line', to: '/category/tv?region=中国大陆' },
  { label: '海外专区', desc: '美剧日韩', icon: 'ri-earth-line', to: '/category/tv?region=韩国' },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-1.5 h-6 md:h-7 rounded-full bg-primary-500"></span>
        <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-50">分类快捷入口</h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {mainEntries.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-950/60 text-primary-400 flex items-center justify-center shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${entry.icon} text-xl md:text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <p className="text-sm md:text-base font-semibold text-foreground-100 truncate">{entry.label}</p>
              <p className="text-xs text-foreground-500 mt-0.5 truncate">{entry.desc}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-4 md:mt-5 flex flex-wrap gap-2 md:gap-3">
        {featuredGenres.map((genre) => (
          <Link
            key={genre}
            to={`/category/movie?genre=${encodeURIComponent(genre)}`}
            className="px-4 py-2 rounded-full text-sm text-foreground-200 bg-secondary-900/60 border border-secondary-700/50 hover:bg-secondary-800 hover:text-foreground-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            {genre}
          </Link>
        ))}
      </div>
    </section>
  );
}